"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.conversationPropTypes = exports.initialState = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  base: [{
    type: 'welcome',
    shown: false,
    timestamp: Date.now()
  }],
  processing: false,
  queue: []
};
exports.initialState = initialState;
var conversationPropTypes = {
  base: _propTypes["default"].arrayOf(_propTypes["default"].object),
  processing: _propTypes["default"].bool,
  queue: _propTypes["default"].arrayOf(_propTypes["default"].object)
};
exports.conversationPropTypes = conversationPropTypes;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.CONVERSATION_CLEAR:
      {
        return _objectSpread({}, state, {
          base: initialState.base
        });
      }

    case _types.CONVERSATION_REMOVE_LAST:
      {
        var messageType = action.payload;
        var messageFound = false;
        var updatedConversation = state.base.reduceRight(function (accumulator, message) {
          if (messageFound || message.type !== messageType) {
            accumulator.unshift(message);
          } else if (message.type === messageType) {
            messageFound = true;
          }

          return accumulator;
        }, []);
        return _objectSpread({}, state, {
          base: updatedConversation
        });
      }

    case _types.CONVERSATION_SET:
      {
        return _objectSpread({}, state, {
          base: action.payload
        });
      }

    case _types.CONVERSATION_PROCESSING_SET:
      {
        return _objectSpread({}, state, {
          processing: action.payload
        });
      }

    case _types.CONVERSATION_QUEUE_CLEAR:
      {
        return _objectSpread({}, state, {
          queue: initialState.queue
        });
      }

    case _types.CONVERSATION_QUEUE_SET:
      {
        return _objectSpread({}, state, {
          queue: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;